
$(document).ready(function(){
  /*$(".nav-btn i").click(function(){	
      $(".navigation-wrap > ul").slideToggle();
    	$( this ).toggleClass( "fa-bars fa-times" );
	});	*/
    $("#SearchIco").click(function(){
      $(".topsearchForm").toggleClass("open");
    });

    $("#SearchIcoM").click(function(){
      $(".topsearchFormM").toggleClass("open");
    });
  
	$(".banner-caro").owlCarousel({ 
       autoPlay: 5000,    
 	  navigation: false,
      pagination: true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsTablet : [998,1],
      // afterAction : afterAction
  	});
  	// function afterAction(){
   //    var item=this.owl.currentItem;
   //    $(".banner-caro .banner-sec img:eq("+item+")").css('opacity',1)
   //  }
  	$(".popular-prod-caro").owlCarousel({ 
      autoPlay: false, 
 	  navigation: false,
      pagination: true,
      items : 4,
      itemsDesktop : [1199,4],
      itemsTablet : [768,3],
      itemsMobile : [480,2]
  	});

    $(".featureinCaro").owlCarousel({ 
      autoPlay: 2000, 
 	  navigation: false,
      pagination: true,
      items : 2,
      itemsDesktop : [1199,1],
      itemsTablet : [768,3],
      itemsMobile : [480,2]
  	});

    $(".featured-cat-caro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: false,
      pagination: true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsTablet : [768,1],
      itemsMobile : [480,2]
  	});

    $(".landingtestiCaro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: false,
      pagination: true,
      items : 4,
      itemsDesktop : [1199,4],
      itemsTablet : [768,3],
      itemsMobile : [480,1]
  	});
    
    $(".desktop-blog-crousel").owlCarousel({ 
        autoPlay: false, 
          navigation: false,
          pagination: true,
          items : 3,
          itemsDesktop : [1199,3],
          itemsTablet : [768,3],
          itemsMobile : [480,2]
    });

    $(".blog-caro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: true,
      pagination: false,
      items : 1,
      itemsDesktop : [1199,1],
      itemsTablet : [768,1],
      itemsMobile : [480,1]
  	});

    $(".highlighter-caro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: false,
      pagination: true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsTablet : [998,2]
  	});
  	
  	$(".cannabinoid-caro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: false,
      pagination: true,
      items : 4,
      itemsDesktop : [1199,4],
      itemsTablet : [768,2]
  	});

    $(".cannalistings").owlCarousel({ 
      autoPlay: false, 
 	  navigation: true,
      pagination: false,
      items : 3,
      itemsDesktop : [1199,3],
      itemsTablet : [998,2],
      itemsMobile : [480,1]
  	});
  	
    $(".location-caro").owlCarousel({ 
      autoPlay: false, 
 	  navigation: false,
      pagination: true,
      items : 4,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [979,4]
  	});

  $(".blckfridaycaro").owlCarousel({ 
      autoPlay: 3000, 
 	  navigation: false,
      pagination: true,
      items : 1,
      itemsDesktop : [1199,1],
      itemsDesktopSmall : [979,1],
      itemsTab : [768,1]
  	});

  $("#moodCaro").owlCarousel({ 
      autoPlay: false, 
 	  navigation: true,
      pagination: false,
      items : 5,
      itemsDesktop : [1199,4],
      itemsTablet : [768,4]
  	});

  $(".faqsecCaro").owlCarousel({ 
      autoPlay: 5000, 
 	  navigation: false,
      pagination: false,
      items : 1,
      itemsDesktop : [1199,1],
      itemsTablet : [998,1],
      itemsMobile : [480,1]
  	});
   $(".location_slider_enabled ul").owlCarousel({ 
      autoPlay: false, 
 	  navigation: false,
      pagination: true,
      items : 4,
      itemsDesktop : [1199,4],
      itemsTablet : [768,3],
      itemsMobile : [480,2]
  	});
  // $(document).on('click','.site-nav--has-dropdown i',function(event){
  //       event.preventDefault()
  //       if ($(this).closest('.site-nav--has-dropdown').hasClass('submenu-visible')) {
  //           $(this).closest('.site-nav--has-dropdown').removeClass('submenu-visible');
  //           $(this).closest('.site-nav--has-dropdown').removeClass("fa-minus").addClass("fa-plus");
  //       } else {
  //          $(this).closest('.site-nav--has-dropdown').addClass('submenu-visible');   
  //          $(this).removeClass("fa-plus").addClass("fa-minus");
  //       }
  //   });

    // $(document).on('click','.first_level.site-nav--has-dropdown>i,.first_level.site-nav--has-dropdown>a',function(event){
    //     event.preventDefault()
    //     if ($(this).closest('.first_level.site-nav--has-dropdown').hasClass('submenu-visible')) {
    //         $(this).closest('.first_level.site-nav--has-dropdown').removeClass('submenu-visible');
    //         $(this).closest('.first_level.site-nav--has-dropdown').find('i:first').removeClass("fa-minus").addClass("fa-plus");
    //     } else {
    //        $(this).closest('.first_level.site-nav--has-dropdown').addClass('submenu-visible');   
    //        $(this).closest('.first_level.site-nav--has-dropdown').find('i:first').removeClass("fa-plus").addClass("fa-minus");
    //     }
    // });
    
    // $(document).on('click','.second_level.site-nav--has-dropdown>i',function(event){
    //     event.preventDefault()
    //     if ($(this).closest('.second_level.site-nav--has-dropdown').hasClass('submenu-visible')) {
    //         $(this).closest('.second_level.site-nav--has-dropdown').removeClass('submenu-visible');
    //         $(this).closest('.second_level.site-nav--has-dropdown').find('i:first').removeClass("fa-minus").addClass("fa-plus");
    //     } else {
    //        $(this).closest('.second_level.site-nav--has-dropdown').addClass('submenu-visible');   
    //        $(this).closest('.second_level.site-nav--has-dropdown').find('i:first').removeClass("fa-plus").addClass("fa-minus");
    //     }
    // });
    
    $(document).on('click', '.first_level.site-nav--has-dropdown > i, .first_level.site-nav--has-dropdown > a', function(event) {
      event.preventDefault();
      var $clickedItem = $(this).closest('.first_level.site-nav--has-dropdown');
      // Close all sibling dropdowns
      $clickedItem.siblings('.first_level.site-nav--has-dropdown').removeClass('submenu-visible')
          .find('i:first').removeClass('fa-minus').addClass('fa-plus');
      // Toggle the clicked dropdown
      if ($clickedItem.hasClass('submenu-visible')) {
          $clickedItem.removeClass('submenu-visible');
          $clickedItem.find('i:first').removeClass("fa-minus").addClass("fa-plus");
      } else {
          $clickedItem.addClass('submenu-visible');
          $clickedItem.find('i:first').removeClass("fa-plus").addClass("fa-minus");
      }
    });
    $(document).on('click', '.second_level.site-nav--has-dropdown > i', function(event) {
        event.preventDefault();
        var $clickedItem = $(this).closest('.second_level.site-nav--has-dropdown');
        // Close sibling dropdowns
        $clickedItem.siblings('.second_level.site-nav--has-dropdown')
            .removeClass('submenu-visible')
            .find('i:first').removeClass('fa-minus').addClass('fa-plus');
        // Toggle clicked item
        if ($clickedItem.hasClass('submenu-visible')) {
            $clickedItem.removeClass('submenu-visible');
            $clickedItem.find('i:first').removeClass("fa-minus").addClass("fa-plus");
        } else {
            $clickedItem.addClass('submenu-visible');
            $clickedItem.find('i:first').removeClass("fa-plus").addClass("fa-minus");
        }
    });


   var get_product_reviews_le = $('#get_product_reviews').length;
   if(get_product_reviews_le == 1){
    if ($(window).width() < 481) {   
     var  myInterval  = setInterval(function () {
        var get_product_reviews_form_length = $('#get_product_reviews').find('form').length;
        if(get_product_reviews_form_length == 1){
          clearInterval(myInterval);
          var get_product_reviews = $('#get_product_reviews').html();
          $('#get_product_reviews').html('empty')
          $('#Mobile_review').html(get_product_reviews)
          
          //console.log('mobile view')        
          //console.log(get_product_reviews)        
        }
      }, 1000);
       
    }
    else {      
        var  myInterval  = setInterval(function () {
        var get_product_reviews_form_length = $('#get_product_reviews').find('form').length;

        
        if(get_product_reviews_form_length == 1){
          clearInterval(myInterval);
          var get_product_reviews = $('#get_product_reviews').html();
          
          $('.Desktop_review').html(get_product_reviews)
          $('#get_product_reviews').html('empty')
          
         // console.log('desktop view')        
         // console.log(get_product_reviews)        
        }
      }, 1000);
               
    }
    }

   if(get_product_reviews_le == 1){
      if($(window).width() < 481) {   
         $(document).on('click','.spr-badge-starrating, .spr-badge-caption',function() {
            let exp = document.querySelectorAll('.showMobile .pdp .accordions'); 
            var i;
            for (i = 0; i < exp.length; ++i) {
                //console.log(exp[i].classList)
                  if(exp[i].innerText.includes('Reviews')){
                   window.scrollTo({
                        top: exp[i].offsetTop,
                        behavior: 'smooth',
                    })
                    if(exp[i].classList.contains('active')){
                      
                    }else{
                       exp[i].click();
                    }
                  
                  }
                      
            };
           
      	});
       }else{
         $(document).on('click','.spr-badge-starrating, .spr-badge-caption',function() {
            let exp_tablinks = document.querySelectorAll('.showDesktop .tablinks'); 
            var j;
            for (j = 0; j < exp_tablinks.length; ++j) {
                if(exp_tablinks[j].innerText.includes('REVIEWS')){
                   window.scrollTo({
                        top: $(".showDesktop .proddescrip-tabination-wrap .tab").offset().top,
                        behavior: 'smooth',
                    })
                    if(exp_tablinks[j].classList.contains('active')){
                     
                    }else{
                       exp_tablinks[j].click();
                    }
                }
                      
            };
      	});
       }
   }

    jQuery(document).on('click','.featured-cat-desktop .moreless-button',function() {
      jQuery('.featured-cat-desktop .moretext').slideToggle();
      if (jQuery(this).text() == "Load More") {
        jQuery(this).text("Load less");
      } else {
        jQuery(this).text("Load More");
      }
    });

   $(".bundle-prod-caro").owlCarousel({ 
      autoPlay: false,
 	  navigation: false,
      pagination: true,
      items : 4,
      margin:10,
      itemsDesktop : [1199,4],
      itemsTablet : [998,3],
      itemsMobile : [680,2]
  	});
  
  
   if($('body').attr('template_name') == 'index'){

        if($(window).width() < 767) {
        $.ajax({
        url:	"/pages/ajax-call-data",
        type:	'GET',
        dataType: 'html',
        success: function(mobileviewdata) {
            $(".featured-cat-wrap .mtop50").before($(mobileviewdata).find('.featured-cat-mob.showMobile')[0].outerHTML);
            $(".featured-cat-wrap .featured-cat-mob.showMobile .featured-cat-caro").owlCarousel({ 
              autoPlay: 3000, 
              navigation: false,
              pagination: true,
              items : 2,
              itemsDesktop : [1199,1],
              itemsTablet : [768,1],
              itemsMobile : [480,2]
            });
        }
        });
        }else{
        $.ajax({
        url:	"/pages/ajax-call-data",
        type:	'GET',
        dataType: 'html',
        success: function(desktopviewdata) {
         
            //console.log($(desktopviewdata).find('.featured-cat-desktop.showDesktop')[0].outerHTML);
            $(".featured-cat-wrap .mtop50").before($(desktopviewdata).find('.featured-cat-desktop.showDesktop')[0].outerHTML);
        }
        });
        }
     
     


   

     
   }

  if($('[data-toggle="tooltip"]').length > 0){
    $('[data-toggle="tooltip"]').tooltip();
  } 
});




	var $titleTab = $('.title_tab');
    if($("body").attr('template_name') !='product'){
       $('.Accordion_item:eq(0)').find('.title_tab').addClass('active').next().stop().slideDown(300);
  	   $('.Accordion_item:eq(0)').find('.inner_content').find('p').addClass('show');
    }
	$titleTab.on('click', function(e) {
	e.preventDefault();
		if ( $(this).hasClass('active') ) {
			$(this).removeClass('active');
			$(this).next().stop().slideUp(500);
			$(this).next().find('p').removeClass('show');
		} else {
			$(this).addClass('active');
			$(this).next().stop().slideDown(500);
			$(this).parent().siblings().children('.title_tab').removeClass('active');
			$(this).parent().siblings().children('.inner_content').slideUp(500);
			$(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
			$(this).next().find('p').addClass('show');
		}
	});

var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    // First close all panels
    for (var j = 0; j < acc.length; j++) {
      acc[j].classList.remove("active");
      acc[j].nextElementSibling.style.display = "none";
    }

    // Open the clicked one
    this.classList.add("active");
    var panel = this.nextElementSibling;
    panel.style.display = "block";
  });
}

var accs = document.getElementsByClassName("accordions");
var i;

for (i = 0; i < accs.length; i++) {
  accs[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panels = this.nextElementSibling;
    if (panels.style.display === "block") {
      panels.style.display = "none";
    } else {
      panels.style.display = "block";
    }
  });
}


// =====//
if($('.seo_content').length > 0 ){
$(document).ready(function(){
	$('.moreless-button').click(function() {
	  $('.moretext').slideToggle();
	  if ($('.moreless-button').text() == "Read more") {
	    $(this).text("Read less")
	  } else {
	    $(this).text("Read more")
	  }
	});

	

  
});

}

document.addEventListener('DOMContentLoaded', function() {
    const chart_btn = document.querySelector('.chart_btn');
    if (chart_btn) {
        // chart_btn.addEventListener('click', function(e) {
        //     e.preventDefault(); 
        //     e.stopPropagation();
        //     const chatToggle = document.querySelector('#ShopifyChat').shadowRoot.querySelector('.chat-toggle');
        //     if (chatToggle) {
        //         chatToggle.click();
        //     } else {
        //         console.error('Chat toggle element not found');
        //     }
        // });
        chart_btn.addEventListener('click', function(e) {
           e.preventDefault(); 
           if (window.tidioChatApi) {
              window.tidioChatApi.open(); 
            } else {
              console.error('Tidio chat API is not available.');
            }
        })
    } 
});
//  City Location Landing Page ""Tab""
var tabcontent = document.getElementsByClassName("tabcontent");
if(tabcontent.length>0){
  function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultOpen").click();
}



// ====================support===================//
    // Check if the script is running on the specified page
    if (window.location.pathname === "/a/support") {
        // Wait for the dynamic content to load
        const interval = setInterval(() => {
            // Select the target container with the class "corner-page-banner-text"
            const contactContainer = document.querySelector(".corner-page-banner-text");

            if (contactContainer) {
                // Check if the new wrapper div is already appended to prevent duplication
                if (!contactContainer.querySelector(".contact-icons-wrapper")) {
                    // Create a wrapper div
                    const wrapperDiv = document.createElement("div");
                    wrapperDiv.className = "contact-icons-wrapper co-flex co-items-center co-justify-center co-mt-5 co-mb-3";

                    // Create the phone call icon element
                    const phoneCallIcon = document.createElement("a");
                    phoneCallIcon.className =
                        "co-contact-icons co-w-10 co-h-10 co-p-2 co-mx-3 co-border-white co-border-solid co-border co-rounded-md co-opacity-70 hover:co-opacity-100 phone-call-icon";
                    phoneCallIcon.href = "tel:512-350-2505"; // Replace with your desired phone number
                    phoneCallIcon.setAttribute("rel", "noreferrer");
                    phoneCallIcon.setAttribute("target", "_blank");

                    const phoneIconImage = document.createElement("img");
                    phoneIconImage.className = "co-w-full";
                    phoneIconImage.src = "https://cdn.shopify.com/s/files/1/0734/5160/2234/files/call-icon.png?v=1733993425"; // Replace with your phone icon URL
                    phoneIconImage.alt = "phone-call-icon";
                    phoneCallIcon.appendChild(phoneIconImage);

                    // Create the email icon element
                    const emailIcon = document.createElement("a");
                    emailIcon.className =
                        "co-contact-icons co-w-10 co-h-10 co-p-2 co-mx-3 co-border-white co-border-solid co-border co-rounded-md co-opacity-70 hover:co-opacity-100 email-icon";
                    emailIcon.href = "mailto:howdy@greenherbalcare.com"; // Replace with your desired email address
                    emailIcon.setAttribute("rel", "noreferrer");
                    emailIcon.setAttribute("target", "_blank");

                    const emailIconImage = document.createElement("img");
                    emailIconImage.className = "co-w-full";
                    emailIconImage.src = "https://assets.cornercart.io/coca-v2/images/contact-icons/mail.svg"; // Replace with your email icon URL
                    emailIconImage.alt = "email-icon";
                    emailIcon.appendChild(emailIconImage);

                    // Append both icons to the wrapper div
                    wrapperDiv.appendChild(phoneCallIcon);
                    wrapperDiv.appendChild(emailIcon);

                    // Append the wrapper div to the contact container
                    contactContainer.appendChild(wrapperDiv);
                }
                // Stop the interval once the container is found and updated
                clearInterval(interval);
            }
        }, 100); // Check every 100ms
    }
// ======================End=====================//

document.addEventListener('click', function (event) {
    console.log('event',event)
    if(event.target.closest('.klaviyo_form_trigger_newsletter_section')){
       window._klOnsite = window._klOnsite || [];
       window._klOnsite.push(['openForm', 'WBHSK3']);
    }
    if(event.target.closest('.klaviyo_form_trigger_desktop')){
       window._klOnsite = window._klOnsite || [];
       window._klOnsite.push(['openForm', 'WBHSK3']);
    }
    if(event.target.closest('.klaviyo_form_trigger_mobile')){
       window._klOnsite = window._klOnsite || [];
       window._klOnsite.push(['openForm', 'WBHSK3']);
    }
  });



// (async function () {
//    if (localStorage.getItem("user_region")) {
//      if (localStorage.getItem("user_region") === "TX") {
//         window._klOnsite = window._klOnsite || [];
// 		    window._klOnsite.push(['openForm', 'WBHSK3']);
//      }else{
//         window._klOnsite = window._klOnsite || [];
//         window._klOnsite.push(['openForm', 'UL3iu4']);
// 	 }
//    return;
//    }
//   const res = await fetch("https://ipapi.co/json/");
//   const data = await res.json();
//    localStorage.setItem("user_region", data.region_code);
//    if (data.region_code === "TX") {
//         window._klOnsite = window._klOnsite || [];
// 		    window._klOnsite.push(['openForm', 'WBHSK3']);
//    }else{
//         window._klOnsite = window._klOnsite || [];
// 		    window._klOnsite.push(['openForm', 'UL3iu4']);
//    }
//  })();        
//  // Save close time
// window.addEventListener("klaviyoForms", function(e) { 
//         if (e.detail.type == 'close') {
//            console.log('klaviyoForms-close')
//            localStorage.setItem("kl_popup_dismissed_at",  Date.now());
//         }
//         if (e.detail.type == 'open') {
//            console.log('klaviyoForms-open')
//         }
//     });

(async function () {
  // 1) Block if dismissed
  const FIVE_DAYS = 5 * 24 * 60 * 60 * 1000;
  const lastDismiss = localStorage.getItem("kl_popup_dismissed_at");
  if (lastDismiss && (Date.now() - lastDismiss) < FIVE_DAYS) {
    console.log("Popup blocked - dismissed recently");
    return;
  }
  // 2) Listen for open/close
  window.addEventListener("klaviyoForms", function(e) { 
    if (e.detail.type == 'close') {
      console.log('klaviyoForms-close');
      localStorage.setItem("kl_popup_dismissed_at", Date.now());
    }
    if (e.detail.type == 'open') {
      console.log('klaviyoForms-open');
    }
  });

  // 3) Your location logic (same as before)
  if (localStorage.getItem("user_region")) {
    if (localStorage.getItem("user_region") === "TX") {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WBHSK3']);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'UL3iu4']);
    }
    return;
  }

  const res = await fetch("https://ipapi.co/json/");
  const data = await res.json();
  localStorage.setItem("user_region", data.region_code);

  if (data.region_code === "TX") {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'WBHSK3']);
  } else {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UL3iu4']);
  }
})();

